import {getTestProps} from '@benchling/js-test-utils';
import {createStyles} from '@mantine/core';
import React, {useCallback, useState} from 'react';

import navigateToURL from 'lib/navigateToURL';
import {ChatSettingsTab} from 'llm/chat-library/sidepanel/AISidepanelV2GlobalClientState';
import {chatSettingsModalUrl} from 'llm/routes/UrlUtils';
import localStorage from 'LocalStorage';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import SidebarRow from './SidebarRow';

export const SET_UP_AN_AGENT_DISMISSED_STORAGE_KEY = 'ai-chat:setup-agent-cta-dismissed';

const useStyles = createStyles((theme) => ({
  newIndicator: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: theme.colors.blue[6],
  },
}));

export default function SetUpAnAgentRow(): JSX.Element {
  const {classes} = useStyles();
  const [showNewIndicator, setShowNewIndicator] = useState(
    () => localStorage.getItem(SET_UP_AN_AGENT_DISMISSED_STORAGE_KEY) !== 'true'
  );

  const handleClick = useCallback(() => {
    localStorage.setItem(SET_UP_AN_AGENT_DISMISSED_STORAGE_KEY, 'true');
    setShowNewIndicator(false);
    navigateToURL(chatSettingsModalUrl(ChatSettingsTab.AGENTS));
  }, []);

  return (
    <SidebarRow
      icon={<BenchlingIcon icon="plus" />}
      label="Set up an Agent"
      onClick={handleClick}
      hoverHighlight={true}
      trailing={
        showNewIndicator ? (
          <span
            aria-hidden={true}
            className={classes.newIndicator}
            {...getTestProps({component: 'SetUpAnAgentRow', element: 'newIndicator'})}
          />
        ) : undefined
      }
      dataTestAttrs={{component: 'SetUpAnAgentRow', element: 'root'}}
    />
  );
}
